import React, { Suspense } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'core-js/stable';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime';
import './windowGlobals';
import ReactDOM from 'react-dom';
import bootstraps from './components/bootstraps';
import '../stylesheets/housecall_common_styles.scss';
import {
  setupSentry,
  addAmplitudeToConfigHeader,
  setupRestApi,
  setupCastle,
  setupBrowserPush,
  setupDataDog
} from './indexHelpers';
import { getEnvironmentVariables } from './environmentVariables';
import { initSegment } from './external-libs/segment';
import { initGoogleMaps } from './external-libs/googleMaps';

const mountComponents = () => {
  const elements = Array.from(document.getElementsByClassName('hcw-component'));

  elements.forEach((componentDiv) => {
    const props = JSON.parse(componentDiv.dataset.props);
    const Component = bootstraps[componentDiv.dataset.component];

    ReactDOM.render(
      <Suspense fallback={<div />}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...props} />
      </Suspense>,
      componentDiv
    );
  });
};

(function () {
  setupDataDog();
  document.addEventListener('DOMContentLoaded', () => {
    getEnvironmentVariables().then(() => {
      initSegment();
      initGoogleMaps();
      setupSentry();
      setupRestApi();
      addAmplitudeToConfigHeader();
      setupCastle();
      setupBrowserPush();
      mountComponents();
    });
  });
})();
